import { atom, useAtomValue, useSetAtom } from 'jotai';

const reviewStatState = atom<Review.Stat>({
  totalNum: 0,
  shopeeNum: 0,
  lazadaNum: 0,
  mercadoNum: 0,
  tiktokNum: 0,
  tiktokUsNum: 0,
});

export const useReviewStat = () => useAtomValue(reviewStatState);
export const useSetReviewStat = () => useSetAtom(reviewStatState);
